import { memo, useMemo } from 'react';
import { useTheme, type Theme } from '@emotion/react';

import googleFontQuery from './googleFontQuery';

function GoogleFonts() {
  const { fonts }: Theme = useTheme();

  const query = useMemo<string[] | null>(() => {
    return googleFontQuery(fonts);
  }, [fonts]);

  if (query?.length) {
    return (
      <link
        rel="stylesheet"
        href={`https://fonts.googleapis.com/css2?family=${query.join(
          '&family='
        )}`}
        media="all"
      ></link>
    );
  }

  return null;
}

export default memo(GoogleFonts);
